// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./UserStatus.module.css";
// CSS
// Models
import { I_Profile } from "../../../Models/interfaces";
// Models
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Services
import { getUserProfile_Service } from "../../../Services/Profile/get/getUserProfile_Service";
// Services
// Modules
import Swal from "sweetalert2";
// Modules
// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { profileImg } from "../../../Images/images";
// Skeleton

const UserStatus = () => {
  // State
  const [userStatus, setUserStatus] = useState<I_Profile>();
  const [isPending, setIsPending] = useState<boolean>(true);
  // State
  // contexts
  const userToken = useContext(UserTokenContext);
  // contexts
  //   LifeCycles
  useEffect(() => {
    if (userToken === "init" || "") return;
    getUserProfile_Service(userToken)
      .then(({ data: { data } }) => {
        setIsPending(false);
        setUserStatus(data);
      })
      .catch((err: any) => {
        console.log(err);
        setIsPending(false);
        if (
          err.response.message === "Unauthenticated" ||
          err.response.message === "UnAuthenticated" ||
          err.response.message === "unAuthenticated" ||
          err.response.message === "unauthenticated"
        ) {
          localStorage.removeItem("amoozesh");
          localStorage.removeItem("amoozeshMeliToken");
          window.location.reload();
          return;
        }
        Swal.fire({
          icon: "error",
          title: err?.response?.data?.message
            ? err?.response?.data?.message
            : err.message,
        });
      });
  }, [userToken]);
  //   LifeCycles

  return isPending ? (
    <>
      <SkeletonTheme
        baseColor="rgba(126, 58, 229 , 0.1)"
        highlightColor="rgba(126, 0, 229, 0.6)"
      >
        <p>
          <Skeleton
            count={1}
            width={"calc(100vw - 2rem)"}
            height={"5vh"}
            style={{ marginTop: "1rem" }}
          />
        </p>
      </SkeletonTheme>
    </>
  ) : (
    <>
      <div
        className={`${styles.userStatusContainer} flex flex-row items-center justify-between p-2  rounded-2xl dark:!text-black`}
      >
        <div
          className={`${styles.left} flex flex-col items-center justify-end dark:!text-black`}
        >
          <p className="text-xs dark:!text-black">
            کیف پول{" "}
            <span className="text-xs dark:!text-black">
              {String(userStatus?.wallet)}
            </span>{" "}
            تومان
          </p>
          <p className="text-xs">
            کیف پول هدیه{" "}
            <span className="text-xs">{String(userStatus?.gift_wallet)}</span>{" "}
            تومان
          </p>
          <span></span>
        </div>
        <div
          className={`${styles.right} flex flex-row-reverse items-center justify-start`}
        >
          <img
            src={
              userStatus?.profile_pic
                ? `https://easyno.ir//users/images/${userStatus?.profile_pic}`
                : profileImg
            }
            alt=""
            className="p-0.5 w-10 h-10 rounded-full"
          />
          <div
            className={`${styles.aboutUser} flex flex-col items-center justify-start mr-2 dark:!text-black`}
          >
            <p>{String(userStatus?.fullName)}</p>
            <p>{String(userStatus?.grade?.title)}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserStatus;
